import { useObservableState } from 'observable-hooks';
import { Observable } from 'rxjs';

export type Nullable<T> = {
   [P in keyof T]: T[P] | null;
};

export type NullablePartial<T> = {
   [P in keyof T]?: T[P] | null;
};

export type ExtractObservableValueType<T> = T extends Observable<infer U> ? U : T;

export type ExtractObservablesValueType<T> = {
   [K in keyof T]: ExtractObservableValueType<T[K]>;
};

export type FacadeObservables<TFacade> = {
   [K in keyof TFacade]: TFacade[K] extends Observable<any> ? K : never;
}[keyof TFacade];

export type UnwrapObservables<TSource> = {
   // [K in keyof TFacade as K extends `${infer R}$` ? R : K]: ReturnType<TFacade[K]> extends Observable<infer U> ? U : never;
   // [K in FacadeObservables<TFacade> as K extends `${infer R}$` ? R : K]: TFacade[K] extends (...args: any[]) => Observable<infer U> ? U : never;
   [Key in keyof TSource as Key extends `${infer R}$` ? R : never]: TSource[Key] extends Observable<infer U> ? U : never;
};

export type FacadeReturnTypes<TFacade> = UnwrapObservables<TFacade>;

export type ExtendFacade<TBase, TExtra> = FacadeReturnTypes<TBase> & FacadeReturnTypes<TExtra>;

export function getObservableProp<TFacade extends object, TDefaults>(facade: TFacade, defaults: TDefaults, prop: keyof TDefaults) {
   type FacadeKey = FacadeObservables<TFacade>;
   const propKey = `${String(prop)}$` as FacadeKey;

   if (propKey in facade) {
      const observableProp = facade[propKey];
      if (observableProp instanceof Observable) {
         // eslint-disable-next-line react-hooks/rules-of-hooks
         return useObservableState(observableProp, defaults?.[prop]);
      }
   }
   // Fallback if no observable or invalid key
   return null;
}
